<template>
    <el-dialog class="commondialog" :class="classname" title="多条件筛选查询" :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="inputdialogtablevisible"  :before-close="handleClose" @open="handleopen" modal="true">
        <span class="l-title">筛选条件</span>
        <!--循环添加筛选条件-->
        <el-row :key="index" class="filtersItem" v-for="(item,index) in filtersArr">
            <el-col :span="7">
                <el-select v-model="filtersArr[index].field" size="mini" class="innerbox" @change="getSelectField(filtersArr[index].field,index)"  placeholder="请选择">
                    <el-option
                        :key="sIndex"
                        v-for="(item,sIndex) in dataOptions"
                        :label="item.name"
                        :value="item.field">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="7">
                <el-select v-model="filtersArr[index].opeator" size="mini" class="innerbox"  placeholder="请选择">
                    <el-option
                        :key="sIndex"
                        v-for="(item,sIndex) in searchOptions"
                        :label="item.text"
                        :value="item.params">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="7">
                <lnk-lov :lov="filtersArr[index].lov" v-model="filtersArr[index].value" class="innerbox" v-if="filtersArr[index].lov"></lnk-lov>
                <el-date-picker v-model="filtersArr[index].value" value-format="yyyy-MM-dd" class="innerbox" size="mini" type="date" v-else-if="filtersArr[index].mark=='DATE'" placeholder="选择日期"></el-date-picker>
                <el-input v-model="filtersArr[index].value" class="innerbox" size="mini" v-else-if="!filtersArr[index].lov&&filtersArr[index].mark!='DATE'"></el-input>
            </el-col>
            <el-col :span="3" v-show="filtersArr.length!=1">
                <i class="el-icon-delete deleteIcon" @click="deleteItemFilters(item,index)"></i>
            </el-col>
        </el-row>
        <el-row class="btnColor">
            <el-col :span="24">
                <el-button size="mini" @click="addFilters" type="primary" icon="el-icon-plus">添加筛选条件</el-button>
            </el-col>
        </el-row>
        <!--内层条件集合-->
        <el-dialog
            class="commondialog innerDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :class="classname"
            width="400px"
            title="查询确认"
            :visible.sync="innerVisible"
            append-to-body>
            <el-row>根据以下条件进行查询</el-row>
            <el-row :key="index" v-for="(item,index) in mlitipArr">
                <span>{{item.name}}</span>&nbsp;&nbsp;
                <span>{{item.params}}</span>&nbsp;&nbsp;
                <span v-if="item.lov">{{lovname(item.value,item.lov)}} ;</span>
                <span v-else>{{item.value}} &nbsp;&nbsp; ;</span>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button @click="innerCancel" class="theme1">{{$t('global.cancel')}}</el-button>
                <el-button type="primary" class="theme2" @click="confirmCondition" >{{$t('global.confirm')}}</el-button>
            </div>
        </el-dialog>

        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelSearch" class="theme1">{{$t('global.cancel')}}</el-button>
            <el-button type="primary" class="theme2" @click="submitForm" >{{$t('global.confirm')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
    /**
     @name:Vue列表多条件查询组件
     @createdby:cjf
     @example template:
     <lnk-more-search class="commondialog" classname="dialogdms"
     :searchvisible.sync="searchVisible"
     :conf="gridOption.fields"
     @getfilterraw="getFilterParams"
     ></lnk-more-search>
     data:{
         searchVisible:false,//多条件查询弹出框是否显示
         gridOption:[//字段配置数据源
            fields:[]//字段配置
         ],
     }
     methods:{
       getFilterParams:function(filtersArr){
            //filtersArr为返回来的查询条件，在页面进行处理进行查询
       }
     }

     @props:
     conf:Array,  //页面加载，获取列表字段配置的数组，用于多条件组合查询字段查询
     classname:String,//查询条件弹出框主体颜色，设置有dms和crm两种颜色 默认为dms的:dialogdms  可选值：dialogdms  dialogcrm

     * */
    export default {
        name: "lnk-more-search",
        data: function () {
            return {
                dataArr: [],
                // 筛选条件的数据源
                filtersArr: [],
                // 待copy的对象
                backCopyObj: {},
                // 从页面获取的字段
                dataOptions: [],
                // 筛选类型
                searchOptions: [
                    {params: '=', text: '等于'},
                    {params: '>', text: '大于'},
                    {params: '<', text: '小于'},
                    {params: '<>', text: '不等于'},
                    {params: 'LIKE', text: '包含'},
                    {params: 'IS NULL', text: '空值'},
                    {params: 'NOT NULL', text: '非空'}

                ],

                innerVisible: false, // 内层dialog

                inputdialogtablevisible: false, // 弹出框是否显示

                mlitipArr: []// 确认展示已选择的查询条件

            };
        },
        props: {
            conf: {
                type: Array,
                default(){
                    return [];
                }
            },
            classname: 'dialogcrm', // 默认为crm样式
            searchvisible: {// 是否显示
                type: Boolean,
                default: false
            }


        },
        watch: {
            searchvisible: function(val){
                this.inputdialogtablevisible = val;
                if(val){
                    // 把获取到的字段赋值给字段筛选
                    this.dataOptions = linkTools.deepCopy(this.conf);
                    // 把获取到数组的第一个字段对象赋值给待copy对象
                    this.backCopyObj = linkTools.deepCopy(this.conf[0]);
                    // 弹出框展现，初始化数据
                    this.filtersArr = [];
                    this.filtersArr.push(linkTools.deepCopy(this.backCopyObj));
                }

            }
        },
        methods: {

            /**
             *@methods:addFilters
             *@description:添加筛选条件
             **/
            addFilters: function(){
                this.filtersArr.push(linkTools.deepCopy(this.backCopyObj));
            },

            /**
             *@methods:deleteItemFilters
             *@description:删除筛选条件
             **/
            deleteItemFilters: function(item, index){
                this.filtersArr.splice(index, 1);
            },

            /**
             *@methods:getSelectField
             *@description:获取field字段
             **/
            getSelectField: function(val, index){
                var fieldoptions = this.filtersArr;
                this.filtersArr[index] = '';
                for(var i = 0; i<this.dataOptions.length; i++){
                    if(val == this.dataOptions[i].field) {
                        this.filtersArr[index] = linkTools.deepCopy(this.dataOptions[i]);
                        this.$set(this.filtersArr, index, fieldoptions[index]);
                    }
                }
            },

            /**
             *@methods:confirmCondition
             *@description:确定查询条件
             **/
            confirmCondition: function(){
                var allfilters = this.mlitipArr;
                var arr = [];
                for(var i = 0; i<allfilters.length; i++){
                    var obj = {};
                    var obj = {id: 'id_rowindex'+i, property: allfilters[i].field, operator: allfilters[i].opeator, value: allfilters[i].value};
                    arr.push(linkTools.deepCopy(obj));
                }
                this.$emit('getfilterraw', arr);
                this.innerVisible = false;
                this.$emit('update:searchvisible', false);
            },

            /**
             *@methods:innerCancel
             *@description:对已编辑好的查询的条件在编辑
             **/
            innerCancel: function(){
                this.innerVisible = false;
            },

            handleopen: function () {
                this.newItem = linkTools.deepCopy(this.addrObject);
            },

            handleClose: function () {
                this.$emit('update:searchvisible', false);
            },

            /**
             *@methods:submitForm
             *@description:确定查询条件,把条件展示在内层dialog
             **/
            submitForm() {
                var conditionArr = this.searchOptions;
                var filtersAll = this.filtersArr;
                for(var i = 0; i<filtersAll.length; i++){
                    if(!filtersAll[i].opeator){
                        this.$message({type: 'warning', message: '请填写完整的查询条件'});
                        return false;
                    }
                    for(var s = 0; s<conditionArr.length; s++){
                        if(filtersAll[i].opeator == conditionArr[s].params){
                            filtersAll[i].params=linkTools.deepCopy(conditionArr[s].text);
                        }
                    }
                }
                this.mlitipArr = linkTools.deepCopy(filtersAll);
                this.innerVisible = true;
            },

            /**
             *@methods:cancelSearch
             *@description:取消多条件查询
             **/
            cancelSearch: function () {
                this.$emit('update:searchvisible', false);
            }
        }
    }
</script>

<style>
    /*多条件查询的弹框*/
    .commondialog{
        margin-right:-17px;
    }
    .commondialog .el-dialog {
        width: 600px;
        height: 420px;
        overflow: hidden;
    }
    .commondialog .el-dialog .el-dialog__header {
        padding: 0;
        height: 46px;
        line-height: 46px;

    }
    .commondialog .el-dialog .el-dialog__title {
        font-size: 14px;
        font-weight: bold;
        margin-left: 16px;
    }
    .commondialog .el-dialog .el-dialog__headerbtn {
        top: 11px;
    }
    .commondialog .el-dialog .el-dialog__body {
        font-size: 12px;
        padding: 0;
        height: 290px;
        background: #F6F7FB;
        padding-top:24px;
        padding-left:35px;
        overflow-y:auto;
        width:590px;
    }
    .commondialog .innerbox .el-input__inner{
        height:28px;
        line-height:28px;
    }
    /*内层dialog*/
    .innerDialog .el-dialog{
        height:278px;
        overflow: hidden;
    }
    .innerDialog .el-dialog  .el-dialog__body{
        width:385px;
        height:150px;
        overflow-y:auto;
    }
    .dialog-footer{
        /* 底部按钮 */
        text-align:center;
    }
    /*输入框统一样式*/
    .commondialog .innerbox .el-input__inner,.commondialog .el-date-editor.el-input{
        width:150px;
    }
    .commondialog .el-form-item{
        margin-bottom:5px;
    }
    .commondialog .l-title{
        font-size: 12px;
        color: #384250;
        letter-spacing: 0;
        text-align: left;
        line-height: 12px;
        margin-bottom:24px;
        display:inline-block;
    }
    .deleteIcon{
        font-size:14px;
    }
    .commondialog .filtersItem{
        margin-bottom:16px;
    }
    .commondialog .deleteIcon{
        cursor:pointer;
    }
    /*crm颜色控制*/
    .dialogcrm .btnColor .el-button{
        background-color:#fff;
        border: 1px solid #1F74FF ;
        color: #1F74FF ;
    }
    .dialogcrm .deleteIcon:hover{
        color: #1F74FF ;
    }
    .dialogcrm .dialog-footer .el-button{
        background-color:#fff;
        border:0;
        height:32px;
        line-height:2px;
    }
    .dialogcrm .dialog-footer .theme2{
        background-color:#1F74FF ;
    }
    .dialogcrm .dialog-footer .theme1{
        border:1px solid #1F74FF ;
        color:#1F74FF ;
    }
    .dialogcrm .dialog-footer .theme1:hover{
        color:#1F74FF ;
    }
    /*dms颜色控制*/
    .dialogdms .btnColor .el-button{
        background-color:#fff;
        border: 1px solid #409eff;
        color: #409eff;
    }
    .dialogdms .deleteIcon:hover{
        color: #409eff;
    }
    .dialogdms .dialog-footer .el-button{
        background-color:#fff;
        border:0;
        height:32px;
        line-height:2px;
    }
    .dialogdms .dialog-footer .theme2{
        background-color:#409eff;
    }
    .dialogdms .dialog-footer .theme1{
        border:1px solid #409eff;
        color:#409eff;
    }
    .dialogdms .dialog-footer .theme1:hover{
        color:#409eff;
    }


</style>
